var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swiper-container"},[_vm._t("parallax-bg"),_vm._v(" "),_c('div',{class:_vm.defaultSwiperClasses.wrapperClass},[_vm._t("default")],2),_vm._v(" "),_vm._t("pagination"),_vm._v(" "),_vm._t("button-prev"),_vm._v(" "),_vm._t("button-next"),_vm._v(" "),_vm._t("scrollbar")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e617127","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-awesome-swiper/src/swiper.vue
// module id = Hpn/
// module chunks = 90